import { useEffect } from 'react';

import { observer } from 'mobx-react-lite';
import styled from 'styled-components';

import { Modal } from '@components/modal';
import { Sidebar } from '@components/sidebar';
import { Toaster } from '@components/toaster';
import { useIntercom } from '@hooks/use-intercom';

import PlaceholderPage from 'components/PlaceholderPage';
import { RouteConfig } from 'components/routes';
import { SeasonalStyles } from 'components/SeasonalStyles';
import { useAuthenticatedUser, useSignOutOn401 } from 'features/authentication';
import { Modals } from 'features/modals';
import { PermissionsProvider } from 'features/permissions';
import { useStore } from 'models/Provider';

export const Authenticated = observer(() => {
  const { current, userStore } = useStore();
  const user = useAuthenticatedUser();
  useSignOutOn401();
  const { setUserData } = useIntercom();

  useEffect(() => {
    setUserData({
      id: user.id,
      email: user.email,
      name: user.name,
      role: user.role,
      language: user.language,
      picture: user.picture,
      companyId: user.company.id,
      companyName: user.company.displayName,
    });
  }, [user, setUserData]);

  if (!userStore?.loaded || !current.info) {
    return <PlaceholderPage />;
  }

  return (
    <PermissionsProvider>
      <Modals />
      <Modal.Provider />
      <Sidebar.Provider />
      <Toaster />
      <SeasonalStyles />
      <Layout>
        <RouteConfig />
      </Layout>
    </PermissionsProvider>
  );
});

const Layout = styled.div({
  display: 'flex',
  height: '100%',
  width: '100%',
  position: 'relative',
  zIndex: 1,
});
